import _ from "lodash";

export const getEmptyResponsesArray = (survey: any) => {
  const arr = [];
  for (let i = 0; i < survey.questions.length; i++) {
    arr.push({
      questionReference: JSON.parse(JSON.stringify(survey.questions[i])),
      response: {},
    });
  }
  return arr;
};

export const safe_get = (obj: any, path: string, defaultValue: any = null) => {
  return _.get(obj, path, defaultValue);
};

export const isEmpty = (obj: any) => {
  if (obj === null || obj === undefined) return true;
  if (Array.isArray(obj) || typeof obj === "string") return obj.length === 0;
  return Object.keys(obj).length === 0;
};

/**
 * Builds a language map from enabled language codes
 * Matches mobile implementation in unifiedrnapp
 * @param enabledLangs - Array of language codes (e.g., ["en", "hi", "kn"])
 * @returns Object mapping language codes to display names (e.g., { en: "English", hi: "Hindi" })
 */
export const buildLanguageMap = (enabledLangs: string[]): Record<string, string> => {
  const languageMap: Record<string, string> = {};
  if (!enabledLangs || !Array.isArray(enabledLangs)) {
    return languageMap;
  }
  
  for (let l of enabledLangs) {
    l = l.trim();
    if (l === "en") languageMap[l] = "English";
    if (l === "ta") languageMap[l] = "Tamil";
    if (l === "hi") languageMap[l] = "Hindi";
    if (l === "ka" || l === "kn") languageMap[l] = "Kannada";
    if (l === "mr") languageMap[l] = "Marathi";
    if (l === "te") languageMap[l] = "Telugu";
    if (l === "bn") languageMap[l] = "Bengali";
    if (l === "ml") languageMap[l] = "Malayalam";
    if (l === "or") languageMap[l] = "Oriya";
    if (l === "gu") languageMap[l] = "Gujarathi";
    if (l === "as") languageMap[l] = "Assamese";
    if (l === "tl") languageMap[l] = "Telugu"; // Telugu can also be "tl"
  }
  return languageMap;
};

